import type { Palette } from "building-types/materials/palette";
import type { PaletteMaterialSlot } from "building-types/materials/paletteMaterialSlotTypes";
import { PaletteType } from "building-types/materials/paletteType";
import type { RoomType } from "building-types/rooms/roomTypesEnum";
import { materialLookupErrorCache, materialSrcFromPalette } from "doc/materialLookup";
import type { MaterialFactory } from "gfx/MaterialFactory";
import { MeshHardcodedMaterialType } from "gfx/MaterialFactory";
import type { Material } from "three";

export async function materialFromPalette(
  materialFactory: MaterialFactory,
  palette: Palette | null,
  paletteSlot?: PaletteMaterialSlot,
  roomType?: RoomType,
): Promise<Material | undefined> {
  if (palette === null) {
    return undefined;
  }

  if (paletteSlot === undefined) {
    if (palette.type === PaletteType.EXTERIOR_PALETTE) {
      return materialFactory.getHardcodedMaterial(MeshHardcodedMaterialType.DEBUG_RED_MESH);
    }
    console.error("Empty material");
    return undefined;
  }

  const materialSrc = materialSrcFromPalette(palette, paletteSlot, roomType);

  if (materialSrc) {
    return await materialFactory.getDesignMaterial(materialSrc);
  }

  if (palette.type === PaletteType.INTERIOR_PALETTE && roomType && !materialLookupErrorCache[paletteSlot]) {
    materialLookupErrorCache[paletteSlot] = true;
    console.error("Could not find material ID: " + paletteSlot);
  }

  return materialFactory.getHardcodedMaterial(MeshHardcodedMaterialType.DEBUG_RED_MESH);
}
